const assertUnreachable = (x)=>`Unreachable code executed with ${x}`;
export { assertUnreachable };
